module.exports = __webpack_public_path__ + "img/11.10ebc5b1.jpg";